export class NOTAM {
  /**
   * GUID that uniquely identifies this NOTAM in the database
   */
  id: string;

  /**
   * FAA identifier for this NOTAM
   */
  notamId: string;

  /**
   * FAA account ID for this NOTAM, usually the associated airport or issuing agent
   */
  accountId: string;

  /**
   * when the NOTAM goes into effect
   */
  effectiveDate: Date;

  /**
   * NOTAM expire Date
   */
  expirationDate: Date;

  /**
   * NOTAM created or modified date
   */
  modifiedDate: Date;

  /**
   * the NOTAMs Q Code
   */
  qCode: string;

  /**
   * the NOTAM raw text
   */
  rawData: string;

  /**
   * the NOTAM report (slightly less raw data)
   */
  report: string;

  /**
   * flag indicating if NOTAM is a TFR
   */
  isTfr: boolean;

  /**
   * URL to the FAA's page for this TFR
   */
  tfrFaaUrl: string;

  /**
   * URL to the iFlightPlanner page for this TFR
   */
  tfrIFlightPlannerForAopaUrl: string;

  /**
   * Parses an NOTAM as returned by the API into an instance of the NOTAM class
   */
  static parse(data: any): NOTAM {
    return Object.assign(new NOTAM(), {
      id: data.id,
      notamId: data.notamId,
      accountId: data.accountId,
      effectiveDate: data.effectiveDate ? new Date(data.effectiveDate) : null,
      expirationDate: data.expirationDate ? new Date(data.expirationDate) : null,
      modifiedDate: data.modifiedDate ? new Date(data.modifiedDate) : null,
      qCode: data.qCode || null,
      rawData: data.rawData || null,
      report: data.report || null,
      isTfr: data.isTfr,
      tfrFaaUrl: data.tfrFaaUrl || null,
      tfrIFlightPlannerForAopaUrl: data.tfrIFlightPlannerForAopaUrl || null
    });
  }
}
